import React from 'react';
import { observer } from 'mobx-react';

import session from '../session';
import Meter from '../uic/Meter';
import Section from '../uic/Section';
import { List, Row, Label, Value } from '../uic/list';

function toDb(val) {
    const peak = parseFloat(val, 10) / 32768;
    return 10 * Math.log10(peak ** 2);
}

class Capture extends React.Component {
    triggerMeter = async () => {
        try {
            const sessionResult = await session.rpc('call', [
                '',
                'instreamer4',
                'status',
                {}
            ]);
            if (sessionResult[1].streaming === 'enabled') {
                const resp = await session.realm.fetch(
                    '/sys/cgi-bin/status.cgi',
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Content-Encoding': 'utf-8'
                        }
                    }
                );

                const { left_peak, right_peak } = JSON.parse(resp);
                if (this._meterLeft) {
                    this._meterLeft.trigger(toDb(left_peak));
                }
                if (this._meterRight) {
                    this._meterRight.trigger(toDb(right_peak));
                }
            }
        } catch (err) {
            console.error('Capture:' + err);
        }
    };

    async componentDidMount() {
        this._timer = setInterval(this.triggerMeter, 500);
    }

    componentWillUnmount() {
        if (this._timer) {
            clearInterval(this._timer);
        }
    }

    render() {
        const { inputsource, inputchannel } = this.props.model;

        let inputchannelreplace = inputchannel;
        if (inputchannelreplace === 'stereo') inputchannelreplace = 'Stereo';
        if (inputchannelreplace === 'mono-right')
            inputchannelreplace = 'Mono Right';
        if (inputchannelreplace === 'mono-left')
            inputchannelreplace = 'Mono Left';

        return (
            <Section title="Capture">
                <List>
                    <Row>
                        <Label>Input</Label>
                        <Value>
                            {inputsource === 'line-in'
                                ? `Line-IN - ${inputchannelreplace}`
                                : `${inputsource} - ${inputchannelreplace}`}
                        </Value>
                    </Row>
                    <Row>
                        <Label>Peak Left</Label>
                        <Value>
                            <Meter ref={ref => (this._meterLeft = ref)} />
                        </Value>
                    </Row>
                    <Row>
                        <Label>Peak Right</Label>
                        <Value>
                            <Meter ref={ref => (this._meterRight = ref)} />
                        </Value>
                    </Row>
                </List>
            </Section>
        );
    }
}

export default observer(Capture);



// WEBPACK FOOTER //
// ./src/sections/Capture.js